/**
 * Comment Template Feature Constants
 *
 * Contains constants for comment template list page configuration,
 * UI text, and interaction behavior.
 */

/**
 * Number of skeleton cards to display while loading
 */
export const SKELETON_CARD_COUNT = 6

/**
 * Default limit for comment template list query
 */
export const DEFAULT_COMMENT_TEMPLATE_LIMIT = 50

/**
 * Default sort order for comment templates (alphabetically by name)
 */
export const DEFAULT_COMMENT_TEMPLATE_SORT = '-created_at'

/**
 * Intersection Observer configuration for infinite scroll
 */
export const INTERSECTION_OBSERVER_CONFIG = {
  root: null,
  rootMargin: '100px',
  threshold: 0.1,
} as const

/**
 * Icon sizes for UI elements
 */
export const ICON_SIZE = {
  plus: 20,
  spinner: 5,
} as const
